import styles from '../../styles/manager/UserList.module.scss'

const UserListHeader = () => {
  const headers = [
    'Avatar Name',
    'Level',
    'School',
    'Phone',
    'Email',
    'Center',
    'Modify',
    'Delete',
  ]

  return (
    <div className={styles.listHeader}>
      {headers.map((header, index) => (
        <div key={index} className={styles.cell}>
          {header}
        </div>
      ))}
    </div>
  )
}

export default UserListHeader
